import Icon from '../components/Icon.vue'

Icon.register({
  helicopter: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M304 384H576C593.7 384 608 369.7 608 352 608 228.3 507.7 128 384 128V64H560C568.8 64 576 56.8 576 48V16C576 7.2 568.8 0 560 0H144C135.2 0 128 7.2 128 16V48C128 56.8 135.2 64 144 64H320V128H112L68.8 70.4C65.8 66.4 61 64 56 64H16C5.6 64-2 73.8 0.5 83.9L32 192 192 256 278.4 371.2A32-32 0 0 1 304 384zM416 195.5C478.6 208.3 528 257.4 540.8 320H416V195.5zM635.4 458.8L613.2 436.6C607 430.4 597 430.5 590.6 436.6 583.5 443.4 576.7 447.9 565.9 447.9H240C231.2 447.9 224 455.1 224 463.9V496C224 504.8 231.2 512 240 512H565.9C580.8 512 601.2 511.5 634.4 482.5 641.4 476.3 642 465.4 635.4 458.8z'
      }
    ]
  }
})
